import { AttributesMixin, define, Model } from "@type-r/models";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";

export interface ImportTemplateActivityDto extends AttributesMixin<typeof ImportTemplateActivityDto> { }

@define
export class ImportTemplateActivityDto extends Model {
    static endpoint = restfulIO('api/v1/import-templates');

    static attributes =
        {
            items:
                [
                    {
                        importJobStatus: String,
                        processedOn: String,
                        fileName: String
                    }
                ]
        }

    async get(id: string): Promise<ImportTemplateActivityDto> {
        const url = `api/v1/ingest/import-templates/${id}/activities`;

        const response = await fetch(url, {
            method: 'GET',
            headers: new Headers({
                "Authorization": getAuthorizationBearer(),
                'X-Platform-Code': getPlatformCode()
            }),
        });

        if (response.status < 200 || response.status >= 300) {
            // TODO in case of not found maybe we have a need in more specific error message
            // TODO like a "Import Template was not found"
            let error = response.statusText || `HTTP Error ${response.status}`;
            await response.json()
                .then(e => error = Object.keys(e.errors).map(k => e.errors[k].join(' ')).join(' '))
                .catch(e => console.error('Cannot parse response data'));
            throw new Error(error);
        }

        const json = await response.json();
        this.set(json);
        return this;
    }
}